var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 3H4.99902C4.46859 3 3.95988 3.21071 3.58481 3.58579C3.20974 3.96086 2.99902 4.46957 2.99902 5V7M16.999 3H18.999C19.5295 3 20.0382 3.21071 20.4132 3.58579C20.7883 3.96086 20.999 4.46957 20.999 5V7M15.999 6.81321V9.01747M7.99902 6.81321V9.01747M11.999 6.81321V10.944H10.999M6.99902 21H4.99902C4.46859 21 3.95988 20.7893 3.58481 20.4142C3.20974 20.0391 2.99902 19.5304 2.99902 19V17M16.999 21H18.999C19.5295 21 20.0382 20.7893 20.4132 20.4142C20.7883 20.0391 20.999 19.5304 20.999 19V17M10.8609 14.5488V16.3667M8.71442 15.0382V15.7657M14.9256 15.2955V15.4442M12.8856 13.6886V17.1958",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtsLogo);
export default __webpack_public_path__ + "static/media/ttsLogo.276569097ea6910d415b854d033d29eb.svg";
export { ForwardRef as ReactComponent };